export const woonenergieRibbonColors = {
  ribbonBackgroundMediumEmphasis: '{{ brandSupport.lightLime }}',
  ribbonColorMediumEmphasis: '{{ textColors.textPrimary }}',

  ribbonBackgroundHighEmphasis: '{{ brandGradients.brandGradient }}',
  ribbonColorHighEmphasis: '{{ textColors.textInverted }}',
};
